import { useTableURLParams } from "src/hooks/useTableURLParams.ts";

type RelatedCasesTableParamsType = {
  identifierValues: string[];
};

export const useRelatedCasesTableURLParams = () => {
  const params: RelatedCasesTableParamsType = {
    identifierValues: [],
  };
  const converters = {
    identifierValues: (value) => (value ? value.split(",") : []),
  };
  return useTableURLParams(params, converters);
};
